/**
 * ActionableSet Context.
 */
import * as React from "react"

type ContextProps = {
  inline: boolean
  rovingElement: HTMLElement | undefined
  setRovingElement: React.Dispatch<
    React.SetStateAction<HTMLElement | undefined>
  >
  state: "INITIAL" | "ROOT" | "CHILD"
}

const initialContext: ContextProps = {
  inline: false,
  rovingElement: undefined,
  setRovingElement: () => {},
  state: "INITIAL"
}
const ActionableSetContext: React.Context<ContextProps> = React.createContext(
  initialContext
)

export default ActionableSetContext
